var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    id: "fi_3132909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.2 5h-22.4c-2.1 0-3.8 1.7-3.8 3.8v14.4c0 2.1 1.7 3.8 3.8 3.8h22.4c2.1 0 3.8-1.7 3.8-3.8v-14.4c0-2.1-1.7-3.8-3.8-3.8zm1.8 18.2c0 .99-.81 1.8-1.8 1.8h-22.4c-.99 0-1.8-.81-1.8-1.8v-14.4c0-.99.81-1.8 1.8-1.8h22.4c.99 0 1.8.81 1.8 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 21h-4c-.5522 0-1 .4478-1 1s.4478 1 1 1h4c.5522 0 1-.4478 1-1s-.4478-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 10h-20c-.5522 0-1 .4478-1 1s.4478 1 1 1h20c.5522 0 1-.4478 1-1s-.4478-1-1-1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.e428cb105f3c9efd90227cb5f2db4329.svg";
export { ForwardRef as ReactComponent };